"use strict";module.exports = {
  _I_: new WeakMap(),
  _H_: new WeakMap(),
  _l_: new WeakMap(),
  aT_: new WeakMap(),
  _G_: new WeakMap(),
  _k_: {}
};